import React from "react";
import { Flex, Box } from "grid-styled";
import { Field, FormSection } from "redux-form";
import { Price } from "../Text";
import { InputContainer, Select, Checkbox } from "../forms";

const NewSaleOptionsFormSection = () => {
  return (
    <FormSection name="options">
      <div>
        <Box pb={2}>
          <Field
            name="serviceLevel"
            labelText="Service Level"
            component={InputContainer}
            fieldComponent={Select}
            options={[
              { level: "1", description: "Level 1 - Plans, Specs & MTO" },
              { level: "2", description: "Level 2 - Plans & Specs (No MTO)" },
              { level: "3", description: "Level 3 - Review Only" }
            ]}
            valueKey="level"
            labelKey="description"
          />
        </Box>
        <Flex wrap>
          <Box width={[1, 1 / 2]} pb={2}>
            <Field name="fullDetailPackage" component={Checkbox}>
              Full Detail Package
            </Field>
          </Box>
          <Box width={[1, 1 / 2]} pb={2}>
            <Field name="includeElevations" component={Checkbox}>
              Include Elevations
            </Field>
          </Box>
          <Box width={[1, 1 / 2]} pb={2}>
            <Field name="rush" component={Checkbox}>
              Rush Turnaround
            </Field>
          </Box>
          <Box width={[1, 1 / 2]} pb={2}>
            <Field name="rushMaterialTakeoff" component={Checkbox}>
              Rush Material Takeoff
            </Field>
          </Box>
          <Box width={[1, 1 / 2]} pb={2}>
            <Field name="structuralCalculations" component={Checkbox}>
              Structural Calculations
            </Field>
          </Box>
          <Box width={[1, 1 / 2]} pb={2}>
            <Field name="pdfStructuralDrawings" component={Checkbox}>
              PDF Structural Drawings
            </Field>
          </Box>
          <Box width={[1, 1 / 2]} pb={2}>
            <Field name="consultationRequest" component={Checkbox}>
              Request Consultation
            </Field>
          </Box>
        </Flex>
      </div>
    </FormSection>
  );
};

export default NewSaleOptionsFormSection;



// WEBPACK FOOTER //
// ./src/components/services/NewSaleOptionsFormSection.js